// extracted by mini-css-extract-plugin
export default {"cardContainer":"gettingstarted_cardContainer__s5+5m","card":"gettingstarted_card__mEGbD","cardTitle":"gettingstarted_cardTitle__WrSGy","cardBody":"gettingstarted_cardBody__r7-Os"};